module.exports = __webpack_public_path__ + "img/flags/SJ.f24fdc2.png";